import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container,
  Row,
  Col,
  Input,
  InputGroup,
  Button,
  Table,
} from 'reactstrap';
import { FiSearch, FiFilter, FiEye, FiEdit, FiUser } from 'react-icons/fi';
import styles from './TimeAttendance.module.css';
import { EmptyState } from '@/components/EmptyState';
// import DatePicker from 'react-datepicker';
// import "react-datepicker/dist/react-datepicker.css";
import BlockUi from 'react-block-ui';
import { pocActionTypes } from '@store/Poc/Poc.actionTypes';
import moment from 'moment';
import 'moment-timezone';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
const TimeAttendance = () => {
  const dispatch = useDispatch();
  const { attendanceData, loading } = useSelector((state) => state.poc);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    dispatch({
      type: pocActionTypes.GET_ATTENDANCE_DATA,
      payload: { companyId: 'sLXRp5fCkzmNjMYUXEAX', date: selectedDate },
    });
  }, [selectedDate, dispatch]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const filteredData = attendanceData;

  const totalItems = attendanceData?.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  console.log('filteredData=====>', filteredData);
  // console.log("totalItems=====>",totalItems);
  // console.log("totalPages=====>",totalPages);

  return (
    <Container fluid className={styles.container}>
      <div className="d-flex justify-content-between align-items-center p-4">
        <h4 className="mb-0">Time & Attendance</h4>
        <div className="d-flex gap-3 align-items-center">
          {/* <DatePicker
            selected={selectedDate}
            onChange={date => setSelectedDate(date)}
            dateFormat="dd/MM/yyyy"
            className="form-control"
          /> */}
          <DatePicker
            onChange={(e) => {
              const date = e?.toDate();
              if (!date) return;
              setSelectedDate(date);
            }}
            value={dayjs(selectedDate)}
          />
          {/* <InputGroup style={{ width: '300px' }}>
            <Input
              className={styles.searchInput}
              placeholder="Search by Name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Button color="primary" className="d-flex align-items-center">
              <FiSearch size={18} />
            </Button>
          </InputGroup>
          <Button color="primary" className="d-flex align-items-center">
            <FiFilter size={18} />
          </Button> */}
        </div>
      </div>

      <div className="bg-white rounded shadow-sm mx-4">
        {loading ? (
          <div className="loader-container">
            <BlockUi tag="div" blocking message="Loading, please wait" />
          </div>
        ) : (
          <>
            <Table hover responsive className={styles.table}>
              <thead className={styles.tableHeader}>
                <tr>
                  <th>Staff Name</th>
                  <th>Location</th>
                  <th>Date</th>
                  <th>Check In</th>
                  <th>Check Out</th>
                  <th>Work time</th>
                  <th>Active Hours</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {filteredData?.length === 0 ? (
                  <tr>
                    <td colSpan="8">
                      <EmptyState
                        illustration
                        title="No Attendance Records"
                        description="No attendance records found for the selected filters."
                      />
                    </td>
                  </tr>
                ) : (
                  filteredData?.map((employee, index) => (
                    <tr key={employee?.id ?? index} className={styles.tableRow}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className={styles.avatar}>
                            {employee?.avatar ? (
                              <img
                                src={employee?.avatar}
                                alt={employee?.name ?? 'Avatar'}
                                className="w-100 h-100 object-fit-cover"
                              />
                            ) : (
                              <div className={styles.avatarPlaceholder}>
                                <FiUser size={24} />
                              </div>
                            )}
                          </div>
                          <div>
                            <div className={styles.employeeName}>
                              {employee?.name ?? employee?.deskId}
                            </div>
                            <div className={styles.employeeId}>
                              {employee?.id}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>{employee?.location ?? 'N/A'}</td>
                      <td>
                        {moment(employee?.date, 'YYYY:MM:DD').format(
                          'MMM DD, YYYY'
                        )}
                      </td>
                      <td>
                        {moment(employee?.check_in)
                          .tz('Asia/Kolkata')
                          .format('hh:mm A')}
                      </td>
                      <td>
                        {moment(employee?.check_out)
                          .tz('Asia/Kolkata')
                          .format('hh:mm A')}
                      </td>
                      <td>
                        {employee?.workTime ?? employee?.total_hours + ' Hrs'}
                      </td>
                      <td>
                        {employee?.activeHours ??
                          employee?.productive_hours + ' Hrs'}
                      </td>
                      {/* <td>
                        <div className="d-flex gap-2">
                          <button className={styles.actionButton} title="View">
                            <FiEye size={18} />
                          </button>
                          <button className={styles.actionButton} title="Edit">
                            <FiEdit size={18} />
                          </button>
                        </div>
                      </td> */}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>

            {/* <div className="d-flex justify-content-between align-items-center p-3 border-top">
              <div>
                Showing
                <select 
                  className="mx-2 form-select form-select-sm d-inline-block" 
                  style={{ width: 'auto' }}
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                of {totalItems} Events
              </div>
              <div className={styles.pagination}>
                <button
                  className={styles.paginationButton}
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                >
                  «
                </button>
                <button
                  className={styles.paginationButton}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  ‹
                </button>
                <button
                  className={`${styles.paginationButton} ${styles.paginationActive}`}
                >
                  {currentPage}
                </button>
                <button
                  className={styles.paginationButton}
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  ›
                </button>
                <button
                  className={styles.paginationButton}
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  »
                </button>
                <span className="ms-2">of {totalPages} pages</span>
              </div>
            </div> */}
          </>
        )}
      </div>
    </Container>
  );
};

export default TimeAttendance;
